interface ErrorMessage {
  message: string;
  type: string;
  heading: string;
}

interface ErrorMessages {
  [key: string]: ErrorMessage;
}

const errorMessages: ErrorMessages = {
  // Register Messages
  REGISTER_EMAIL_REQUIRED: {
    message: 'Email is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  REGISTER_EMAIL_FORMAT_NOT_VALID: {
    message: 'Email format is invalid.',
    type: 'Error',
    heading: 'Validation',
  },
  REGISTER_FIRSTNAME_REQUIRED: {
    message: 'First name is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  REGISTER_LASTNAME_REQUIRED: {
    message: 'Last name is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  REGISTER_PASSWORD_REQUIRED: {
    message: 'Password is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  REGISTER_PASSWORD_LENGTH: {
    message: 'Password must be at least 8 characters long.',
    type: 'Error',
    heading: 'Password Requirement',
  },
  REGISTER_PASSWORD_CRITERIA_NOT_MATCH: {
    message: 'Password must contain an uppercase, a lowercase, a number and a special character.',
    type: 'Error',
    heading: 'Password Requirement',
  },
  REGISTER_VERIFICATION_EMAIL_SENT: {
    message: 'A verification link has been sent on your registered email ID.',
    type: 'Info',
    heading: 'Verification Email Sent',
  },
  REGISTERATION_COMPLETE: {
    message: 'Your registration is complete, Please log in to access the application.',
    type: 'Info',
    heading: 'Registration Complete',
  },
  REGISTER_EMAIL_ALREADY_EXISTS: {
    message: 'The username or email already exists.',
    type: 'Error',
    heading: 'Email Exists',
  },
  REGISTER_COMPANY_NOT_REGISTERED: {
    message: 'An error has occurred. Please contact your administrator for assistance.',
    type: 'Error',
    heading: 'Error',
  },
  REGISTER_EMAIL_TOKEN_NOT_VALIDATE: {
    message: "The verification link is not valid. Please ensure you've clicked on the correct link.",
    type: 'Error',
    heading: 'Invalid Email Verification Link',
  },
  REGISTER_EMAIL_TOKEN_IS_EXPIRED: {
    message: 'Your email ID has not been verified because the link has expired. Please sign up again',
    type: 'Error',
    heading: 'Email Verification Link Expired',
  },
  REGISTER_EMAIL_TOKEN_IS_VALIDATE_SUCCESSFULLY: {
    message: 'Your email ID has been verified successfully. Account Verification is now pending with your administrator.',
    type: 'Success',
    heading: 'Email Verification Successful',
  },
  REGISTER_VERIFICATION_PENDING: {
    message: 'Your email ID was verified. Account verification is pending with your administrator.',
    type: 'Info',
    heading: 'Account Verification Pending',
  },
  REGISTER_EMAIL_VERIFICATION_PENDING: {
    message: 'Your email ID has not been verified. Please check your inbox to verify.',
    type: 'Info',
    heading: 'Email Verification Pending',
  },

  // Login Messages
  LOGIN_EMAIL_REQUIRED: {
    message: 'Email is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  LOGIN_EMAIL_FORMAT_NOT_VALID: {
    message: 'Email format is invalid.',
    type: 'Error',
    heading: 'Validation',
  },
  LOGIN_PASSWORD_REQUIRED: {
    message: 'Password is required.',
    type: 'Error',
    heading: 'Input Required',
  },
  LOGIN_PASSWORD_LENGTH: {
    message: 'Password must be at least 8 characters long.',
    type: 'Error',
    heading: 'Password Requirement',
  },
  LOGIN_PASSWORD_CRITERIA_NOT_MATCH: {
    message: 'Password must contain an uppercase, a lowercase, a number and a special character.',
    type: 'Error',
    heading: 'Password Requirement',
  },
  LOGIN_FAILED_INCORRECT_EMAIL_PASSWORD: {
    message: 'Incorrect username or password.',
    type: 'Error',
    heading: 'Validation',
  },
  LOGIN_ACCOUNT_LOCKOUT: {
    message: 'Account temporarily locked due to multiple failed attempts. Retry in 60 minutes.',
    type: 'Error',
    heading: 'Account Locked',
  },
  LOGIN_USER_IS_INACTIVE: {
    message: 'User not found. Please contact your administrator for further assistance.',
    type: 'Error',
    heading: 'Error',
  },
  LOGIN_ACTIVE_TOKEN_FOUND_LOGOUT_TO_CONTINUE: {
    message:
      'Simultaneous logins from multiple devices/locations are not allowed. To login, please log out from the active session. Note: Logging out will terminate the active session & any unsaved data will be lost.',
    type: 'Warning',
    heading: 'Multiple Logins Detected',
  },

  // Logout Messages
  USER_INACTIVITY_TIMEOUT: {
    message: 'For security reasons, your session has timed out due to inactivity. Please log in again to access the application.',
    type: 'Error',
    heading: 'Session Timed Out',
  },

  //forget password messages
  FORGET_PASSWORD_SUCCESS: {
    message: 'A reset link has been sent to your registered email ID.',
    type: 'Success',
    heading: 'Reset Link Sent',
  },
  FORGET_PASSWORD_USER_NOT_FOUND: {
    message: 'Entered email address is invalid.',
    type: 'Error',
    heading: 'Validation',
  },
  FORGET_PASSWORD_INACTIVE_USERS: {
    message: 'User not found.',
    type: 'Error',
    heading: 'Error',
  },
  RESET_LIMIT_EXCEEDED: {
    message: 'Password reset attempt limit exceeded. Please try again after 24 hours.',
    type: 'Error',
    heading: 'Password Reset Limit Exceeded',
  },
  FORGOT_PASSWORD_LIMIT_EXCEEDED: {
    message: 'Password reset attempt limit exceeded. Please try again after 24 hours.',
    type: 'Error',
    heading: 'Password Reset Limit Exceeded',
  },
  FORGOT_PASSWORD_INVALID_EMAIL_FORMAT: {
    message: 'Email format is invalid.',
    type: 'Error',
    heading: 'Input Required',
  },

  // reset password messages
  RESET_PASSWORD_TOKEN_EXPIRED: {
    message: 'The password reset link has expired. Please try again.',
    type: 'Error',
    heading: 'Reset Password Link Expired',
  },
  CHANGE_PASSWORD_SUCCESS: {
    message: 'Password has been reset. Please login with your new password.',
    type: 'Success',
    heading: 'Password Reset Successful',
  },
  RESET_PASSWORD_LINK_INVALID: {
    message: "The reset link is not valid. Please ensure you've clicked on the correct link.",
    type: 'Error',
    heading: 'Invalid Password Reset Link',
  },

  // add company super admin
  COMPANY_NAME_ALREADY_EXISTS: {
    message: 'Company name already exists.',
    type: 'Error',
    heading: 'Company Exist',
  },
  VAT_ALREADY_EXISTS: {
    message: 'VAT already exists.',
    type: 'Error',
    heading: 'VAT Exist',
  },
  COMPANY_ONBOARDED_SUCCESSFULLY: {
    message: 'Company onboarded successfully.',
    type: 'Success',
    heading: 'Company Onboarded',
  },
  COMPANY_UPDATED_SUCCESSFULLY: {
    message: 'Company details have been updated successfully.',
    type: 'Success',
    heading: 'Company updated',
  },

  COMPANY_DISABLED_SUCCESSFULLY: {
    message: 'Company has been disabled from the company list.',
    type: 'Success',
    heading: 'Company updated',
  },

  COMPANY_REENABLED_SUCCESSFULLY: {
    message: 'Company has been enabled in the company list.',
    type: 'Success',
    heading: 'Company updated',
  },

  // add material product admin
  NEW_MATERIAL_ADDED_SUCCESSFULLY: {
    message: 'New material added successfully.',
    type: 'Success',
    heading: 'Material Added',
  },
  MATERIAL_NAME_ALREADY_EXISTS: {
    message: 'Material name already exists.',
    type: 'Error',
    heading: 'Validation',
  },
  MATERIAL_UPDATED_SUCCESSFULLY: {
    message: 'Material updated successfully.',
    type: 'Success',
    heading: 'Success',
  },
  MATERIAL_NAME_NOT_FOUND: {
    message: 'Material name not found.',
    type: 'Error',
    heading: 'Validation',
  },
  MATERIAL_NOT_FOUND: {
    message: 'Material not found.',
    type: 'Error',
    heading: 'Validation',
  },
  DIMENSION_SHOULD_BE_MORE_THEN_OR_EQUAL_TO_3: {
    message: 'Please select at least 3 dimensions.',
    type: 'Error',
    heading: 'Validation',
  },
  DIMENSION_SHOULD_BE_LESS_THEN_OR_EQUAL_TO_5: {
    message: 'Maximum 5 dimensions can be selected.',
    type: 'Error',
    heading: 'Validation',
  },
  MEASUREMENT_SHOULD_BE_MORE_THEN_OR_EQUAL_TO_1: {
    message: 'Please select at least 1 measurement.',
    type: 'Error',
    heading: 'Validation',
  },
  MEASUREMENT_SHOULD_BE_LESS_THEN_OR_EQUAL_TO_2: {
    message: 'Maximum 3 measurements can be selected.',
    type: 'Error',
    heading: 'Validation',
  },
  MATERIAL_NOT_FOUND_OR_ALREADY_DELETED: {
    message: 'Material not found or has already been deleted.',
    type: 'Error',
    heading: 'Validation',
  },
  FILE_TEMPLATE_HAVE_MULTIPLE_SHEET: {
    message: 'The template must contain a single sheet with the correct format and valid values.',
    type: 'Error',
    heading: 'Validation',
  },
  THIS_FIELD_IS_MANDATORY: {
    message: 'This field is mandatory.',
    type: 'Error',
    heading: 'Validation',
  },
  MATERIAL_DELETED_SUCCESSFULLY: {
    message: 'Selected material deleted successfully.',
    type: 'Success',
    heading: 'Material Deleted',
  },

  //add material product admin bulk upload
  FILE_TEMPLATE_IS_MISSING: {
    message: 'The template you are trying to upload is invalid. Please download the valid template.',
    type: 'Error',
    heading: '',
  },
  FILE_HEADERS_ARE_MISSING: {
    message: 'The template you are trying to upload is empty or without headers.',
    type: 'Error',
    heading: 'Validation',
  },
  FILE_HAS_MULTIPLE_SHEETS: {
    message: 'The template you are trying to upload is having multiple sheets.',
    type: 'Error',
    heading: 'Validation',
  },
  HEADER_MISMATCH: {
    message: 'The template you are trying to upload is having mismatched headers.',
    type: 'Error',
    heading: 'Validation',
  },
  INVALID_FIELD_VALUE: {
    message: 'Please upload valid values for the given fields. Kindly refer the template.',
    type: 'Error',
    heading: '',
  },
  MISSING_MANADATORY_FIELDS: {
    message: 'Please upload all mandatory fields.',
    type: 'Error',
    heading: '',
  },

  // add Process admin
  NEW_PROCESS_ADDED_SUCCESSFULLY: {
    message: 'New Process added successfully.',
    type: 'Success',
    heading: 'Process Added',
  },
  PROCESS_NAME_ALREADY_EXISTS: {
    message: 'Process name already exists.',
    type: 'Error',
    heading: 'Validation',
  },
  PROCESS_UPDATED_SUCCESSFULLY: {
    message: 'Process updated successfully.',
    type: 'Success',
    heading: 'Success',
  },
  PROCESS_UPDATED_FAILED: {
    message: 'Process update failed.',
    type: 'Error',
    heading: 'Error',
  },
  PROCESS_NAME_NOT_FOUND: {
    message: 'Process name not found.',
    type: 'Error',
    heading: 'Validation',
  },
  PROCESS_NOT_FOUND: {
    message: 'Process not found.',
    type: 'Error',
    heading: 'Validation',
  },
  PARAMETER_SHOULD_BE_LESS_THEN_OR_EQUAL_TO_10: {
    message: 'Maximum 10 parameters can be selected.',
    type: 'Error',
    heading: 'Validation',
  },
  PROCESS_NOT_FOUND_OR_ALREADY_DELETED: {
    message: 'Process not found or has already been deleted.',
    type: 'Error',
    heading: 'Validation',
  },
  PROCESS_DELETED_SUCCESSFULLY: {
    message: 'Selected process deleted successfully.',
    type: 'Success',
    heading: 'Process Deleted',
  },
  UNABLE_TO_EDIT_MACHINE_AS_IT_IS_LINKED_TO_PRODUCT_REFERENCE_PART:{
    message: 'Unable to edit the process as it is linked to a product reference.',
    type:'Warning',
    heading:'Warning'
  },
  //Add machine
  NEW_MACHINE_ADDED_SUCCESSFULLY: {
    message: 'New machine added successfully.',
    type: 'Success',
    heading: 'Machine Added',
  },
  MACHINE_MODEL_ALREADY_EXISTS_FOR_THIS_COMPANY: {
    message: 'Machine name already exists.',
    type: 'Error',
    heading: 'Validation',
  },
  MACHINE_UPDATED_SUCCESSFULLY: {
    message: 'Machine updated successfully.',
    type: 'Success',
    heading: 'Success',
  },
  MACHINE_NAME_NOT_FOUND: {
    message: 'Machine name not found.',
    type: 'Error',
    heading: 'Validation',
  },
  NEW_MACHINE_ADDED_FAILED: {
    message: 'Machine name not found.',
    type: 'Error',
    heading: 'Validation',
  },
  MACHINE_NOT_FOUND: {
    message: 'Machine not found.',
    type: 'Error',
    heading: 'Validation',
  },
  PROCESS_SHOULD_NOT_BE_MORE_THEN_OR_5: {
    message: 'Maximum 5 dimensions can be selected.',
    type: 'Error',
    heading: 'Validation',
  },
  MACHINE_DELETED_SUCCESSFULLY: {
    message: 'Selected machine deleted successfully.',
    type: 'Success',
    heading: 'Machine Deleted',
  },

  //product create
  STATUS_UPDATED_SUCCESSFULLY: {
    message: 'Product reference part updated successfully.',
    type: 'Success',
    heading: 'Reference Part Updated',
  },
  PRODUCT_REFERENCE_CREATED_SUCCESSFULLY: {
    message: 'Product reference part created successfully.',
    type: 'Success',
    heading: 'Reference Part Created',
  },
  PRODUCT_REFERENCE_UPDATED_SUCCESSFULLY: {
    message: 'Product reference part updated successfully.',
    type: 'Success',
    heading: 'Reference Part Updated',
  },
  PRODUCT_REFERENCE_DELETED_SUCCESSFULLY: {
    message: 'Reference part deleted successfully.',
    type: 'Success',
    heading: 'Reference Part Deleted',
  },
  REFERENCE_PART_ALREADY_EXISTS: {
    message: 'Reference part already exists.',
    type: 'Error',
    heading: 'Validation',
  },
  REFERENCE_PART_NOT_FOUND: {
    message: 'Reference part not found.',
    type: 'Error',
    heading: 'Validation',
  },
  PRODUCT_REFERENCE_MATERIAL_CREATED_SUCCESSFULLY: {
    message: 'Product reference material added successfully.',
    type: 'Success',
    heading: 'Material Added',
  },
  PRODUCT_REFERENCE_MATERIAL_UPDATED_SUCCESSFULLY: {
    message: 'Product reference material updated successfully.',
    type: 'Success',
    heading: 'Material Updated',
  },
  PRODUCT_REFERENCE_PROCESS_UPDATED_SUCCESSFULLY: {
    message: 'Product reference process updated successfully.',
    type: 'Success',
    heading: 'process updated',
  },
  REFERENCE_PART_IS_MISSING: {
    message: 'Product reference part is missing.',
    type: 'Success',
    heading: 'validation',
  },
  PRODUCT_REFERENCE_MATERIAL_CREATED_FAILED: {
    message: 'Failed to create product reference material.',
    type: 'Error',
    heading: 'Error',
  },
  PRODUCT_REFERENCE_MATERIAL_ALREADY_EXISTS: {
    message: 'Product reference material already exists.',
    type: 'Error',
    heading: 'Error',
  },
  MATERIAL_CONFIG_MAPPING_NOT_FOUND: {
    message: 'Material configuration mapping not found.',
    type: 'Error',
    heading: 'Validation',
  },
  PRODUCT_REFERENCE_PROCESS_CREATED_SUCCESSFULLY: {
    message: 'Product reference process added successfully.',
    type: 'Success',
    heading: 'Process Added',
  },
  PRODUCT_REFERENCE_PART_IS_ASSOCIATED_WITH_PCF_DECLARATION: {
    message: 'Reference part cannot be deleted as it is linked with PCF Declaration.',
    type: 'Error',
    heading: 'Error',
  },
  MATERIAL_IS_ASSOCIATED_WITH_PROCESS: {
    message: 'Material can not be deleted due to associated with process.',
    type: 'Error',
    heading: 'Validation',
  },
  PRODUCT_REFERENCE_PROCESS_CREATED_FAILED: {
    message: 'Failed to create product reference process.',
    type: 'Error',
    heading: 'Error',
  },
  PRODUCT_REFERENCE_PROCESS_ALREADY_EXISTS: {
    message: 'Product reference process already exists.',
    type: 'Error',
    heading: 'Error',
  },
  PROCESS_STEP_DELETED_SUCCESSFULLY: {
    message: 'Selected process deleted successfully.',
    type: 'Success',
    heading: 'Process Deleted',
  },
  MATERIAL_STEP_DELETED_SUCCESSFULLY: {
    message: 'Selected material deleted successfully.',
    type: 'Success',
    heading: 'Material Deleted',
  },
  PCF_CREATED_SUCCESSFULLY: {
    message: 'Product reference part added successfully.',
    type: 'Success',
    heading: 'Process reference added',
  },
  BATCH_ALREADY_EXISTS: {
    message: 'Product reference part batch already exists.',
    type: 'Error',
    heading: 'Error',
  },
  PCF_CREATED_FAILED: {
    message: 'Product reference part creation failed.',
    type: 'Error',
    heading: 'Error',
  },
  PRODUCT_MASTER_DATA_NOT_FOUND: {
    message: 'Product master data not found.',
    type: 'Error',
    heading: 'Error',
  },
  PCF_CALCULATE_SUCCESSFULLY: {
    message: 'PCF calculation has been saved successfully.',
    type: 'Success',
    heading: 'Success',
  },
  PCF_REPORT_UPDATED_SUCCESSFULLY: {
    message: 'PCF Report has been updated successfully.',
    type: 'Success',
    heading: 'Success',
  },
  PCF_REPORT_GENERATED_SUCCESSFULLY: {
    message: 'PCF Report has been saved successfully.',
    type: 'Success',
    heading: 'Success',
  },
  IMAGE_SUCCESSFULLY_UPLOADED: {
    message: 'Image successfully uploaded.',
    type: 'Success',
    heading: 'Success',
  },
  DOCUMENT_DB_FILE_LIMIT_EXCEEDED: {
    message: 'You can only upload up to 10 files.',
    type: 'Error',
    heading: 'Error',
  },
  PCF_UPDATED_SUCCESSFULLY: {
    message: 'Product reference part updated successfully.',
    type: 'Success',
    heading: 'Process reference updated',
  },
  ORDER_DELETED_SUCCESSFULLY: {
    message: 'PCF enquiry has been deleted successfully.',
    type: 'Success',
    heading: 'PCF Enquiry Deleted',
  },
  UNABLE_TO_REMOVE_MATERIAL_AS_IT_IS_LINKED_TO_PRODUCT_REFERENCE_PART: {
    message: 'Unable to remove the material as it is linked to a product reference part.',
    type: 'Error',
    heading: 'Error',
  },
  UNABLE_TO_REMOVE_PROCESS_AS_IT_IS_LINKED_TO_PRODUCT_REFERENCE_PART: {
    message: 'Unable to remove process as it is linked to product reference part.',
    type: 'Error',
    heading: 'Error',
  },
  UNABLE_TO_REMOVE_MACHINE_AS_IT_IS_LINKED_TO_PRODUCT_REFERENCE_PART: {
    message: 'Unable to remove machine as it is linked to product reference part.',
    type: 'Error',
    heading: 'Error',
  },
  SCOPE_ESTIMATE_ADDED_SUCCESSFULLY: {
    message: 'CCF estimate adjustment has been updated successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },

  SCOPE_ESTIMATE_UPDATED_SUCCESSFULLY: {
    message: 'CCF estimate adjustment has been updated successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },

  SCOPE_ESTIMATE_ADDED_SUCCESSFULLY_1: {
    message: 'CCF estimated values for scope 1 have been updated successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  SCOPE_ESTIMATE_ADDED_SUCCESSFULLY_2: {
    message: 'CCF estimated values for scope 2 have been updated successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  SCOPE_ESTIMATE_ADDED_SUCCESSFULLY_3: {
    message: 'CCF estimated values for scope 3 have been updated successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  AGREE_CONFIRM: {
    message: 'CCF estimated values have been saved successfully.',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  SCOPE_CREATED_SUCCESSFULLY: {
    message: 'CCF actual values for {month} have been saved successfully',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  POPUP_BLOCKED: {
    message:
      "To download the declaration in the device, ensure that your browser's pop-up blocker is disabled. Once disabled, please refresh the page and try again.",
    type: 'Success',
    heading: '',
  },
  COMPANY_ADMIN_INVITATION_EMAIL_SENT_SUCCESS: {
    message: 'Invitation Link Sent.',
    type: 'Success',
    heading: 'Success',
  },
  COMPANY_ADMIN_EXISTS_FOR_THIS_COMPANY: {
    message: 'This company already has an assigned Company Admin.',
    type: 'Error',
    heading: '',
  },
  COMPANY_ADMIN_RE_INVITATION_SUCCESS: {
    message: 'Invitation link has been resent successfully.',
    type: 'Success',
    heading: 'Success',
  },
  COMPANY_ADMIN_INVITATION_LIMIT_EXCEEDED: {
    message: 'The maximum number of resend invitation attempts has been reached. Please try again after 24 hours.',
    type: 'Error',
    heading: '',
  },
  EMAIL_NOT_VERIFIED: {
    message: 'Cannot add user as email not verified after sign-up.',
    type: 'Error',
    heading: '',
  },

  COMPANY_EMAIL_ALREADY_EXISTS: {
    message: 'Email address already exists',
    type: '',
    heading: '',
  },
  INVALID_EMAIL: {
    message: 'Incorrect email address format.',
    type: '',
    heading: '',
  },
  LOGO_UPLOADED_SUCESSFULLY: {
    message: 'Company logo uploaded successfully',
    type: 'Success',
    heading: 'Success',
  },
  // FILE_IS_MISSING: {
  //   message: "Image file i.",
  //   type: "Success",
  //   heading: "Process reference added",
  // }
  IMAGE_REMOVED: {
    message: 'Image successfully removed.',
    type: 'Success',
    heading: '',
  },
  COMPANY_DOMAIN_MISMATCH: {
    message: 'Unable to send invitation link as the company domain is not included in the approved domain list.',
    type: 'Error',
    heading: '',
  },
  WAREHOUSE_CREATED_SUCCESSFULLY: {
    message: 'New warehouse added successfully.',
    type: 'Success',
    heading: '',
  },
  WAREHOUSE_UPDATED_SUCCESSFULLY: {
    message: 'Warehouse has been updated successfully.',
    type: 'Success',
    heading: '',
  },
  WAREHOUSE_DELET_WARNING: {
    message: 'Are you sure you want to delete the warehouse?',
    type: 'Warning',
    heading: 'Warning',
  },
  WAREHOUSE_DELETED_SUCCESSFULLY: {
    message: 'Warehouse has been deleted successfully.',
    type: 'Success',
    heading: '',
  },
  WAREHOUSE_LINKED_TO_CCF_PCF_OR_PRODUCT: {
    message: 'This warehouse cannot be deleted as it is linked to a CCF, PCF, or Product.',
    type: 'Error',
    heading: 'Unable to Delete',
  },
  DOCUMENT_DB_LINKED_TO_PRODUCT_OR_PCF: {
    message: 'This file cannot be deleted as it is linked to a Product or PCF.',
    type: 'Error',
    heading: 'Unable to Delete',
  },
  WAREHOUSE_ALREADY_EXISTS: {
    message: 'The warehouse address already exists. Please review the warehouse list.',
    type: 'Error',
    heading: '',
  },
  USERS_EXISTS_FOR_THIS_DOMAIN: {
    message: 'Domain deletion is not permitted while active users are associated with it.',
    type: 'Error',
    heading: '',
  },
  ACTIVE_ADMIN_EXISTS: {
    message: 'A company admin already exists. To assign this user as the new company admin, please disable the existing one.',
    type: 'Error',
    heading: '',
  },
  PRODUCT_HAS_UNSAVED_CHNAGES:{
    message:'Unsaved material/process data will be lost. Are you sure you want to continue?',
    type: 'Warning',
    heading: '',
  },
  PCF_ENQURIY_CHANGES:{
    message:'Are you sure you want to update the existing content as it will replace the previously generated PCF Declaration?',
    type: 'Warning',
    heading: '',
  },
  PCF_UPDATED_SUCCESS:{
    message:'Product reference part updated successfully.',
    type: 'Success',
    heading: '',
  },
  DUPLICATE_ORDER_DATA_ENTERED: {
    message: 'Order already exists. The Customer Name, Customer Order and batch ID must be unique.',
    type: 'Warning',
    heading: 'Warning'
  },
  CCF_EMISSION_SUBMITTED: {
    message: 'CCF emission values have been saved successfully.',
    type: 'Success',  
    heading: 'Success'
  },
  EMISSION_DATA_NOT_FOUND:{
    message: 'CCF Emission (previous year) and/or Annual Sales Volume (Kg) are missing. If you have the CCF user role, please complete these details to proceed with product reference creation. Otherwise, request the assigned CCF user to fill the information.',
    type: 'Error',
    heading: 'Error',
  },
   CREATE_PRODUCT_REFERENCE: {
    message: 'Are you sure you want to create the product reference?',
    type: 'Warning',
    heading: ''
  },
  DRAFT_SAVED_SUCCESSFULLY:{
    message: 'CCF actual values for {month} have been saved successfully',
    type: 'Success',
    heading: 'Scope added successfully.',
  },
  TEMPLATE_MODIFIED:{
    message: 'The template content appears to have been modified. Please update only the input fields and upload again.',
    type: 'Error',
    heading: 'Error.',
  },
  COMPANY_NOT_ACTIVE_OR_FORM_PENDING:{
    message: 'Your account is inactive, or required company details are missing.',
    type: 'Error',
    heading: 'Error',
  },
  COMPANY_NOT_ENABLED:{
    message: 'This user cannot be enabled because their company is disabled.',
    type: 'Error',
    heading: 'Error',
  }
 };

export const genericMessage = {
  message: 'An error occurred. Please try again later.',
  type: 'Error',
  heading: 'Error',
};

export const getErrorMessage = (key: string): ErrorMessage => errorMessages[key] || genericMessage;
